
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../../../assets/styles/verificationPortal.css";
import { FaRegClipboard, FaCheck, FaExternalLinkAlt } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";


import {getPendingProduct, updateProduct, validateProduct} from '../../../Services/DataServices.js'

const VerificationPortal = () => {
    const { fileId, id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const _file = queryParams.get('_file');
    //const { _file } = useQuery();
    const navigate = useNavigate();
    document.title = "Curate manully"

    const [product, setProduct] = useState(null);
    const [formData, setFormData] = useState({
        PRODUCT: "",
        CASNUMBER: "",
        uniqueProductName: "",
        PRODUCT_GROUP: "",
    });
    const [error, setError] = useState("");
    const [copied, setCopied] = useState(false);
    const [copiedClass, setCopiedClass] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    const fetchProduct = async (fileId, _file, id) => {
        try {
            const res = await getPendingProduct({fileId,_file, id});
            setProduct(res.data);
            setFormData({
                PRODUCT: res.data.productName,
                CASNUMBER: res.data.casNos,
                uniqueProductName: res.data.casUpns.toUpperCase(),
            });
            setError("");
        } catch (err) {
            setProduct(null);
            setError(err.response?.data?.message || "Error fetching product");
        }
    };

    useEffect(() => {
        fetchProduct(fileId, _file,id, fileId);
    }, [id,fileId,_file]);

    const handleNavigate = async(direction) => {
        const currentId = parseInt(id, 10);
        if (isNaN(currentId)) return;
        const newId = direction === "next" ? currentId + 1 : currentId - 1;
        if (newId < 1) return;
        //navigate(`/dashboard/${newId}`);
        // if (direction === "next") {
        //     const update = await validateProduct({fileId,_file,id})
        // }
        navigate(`/verification/${fileId}/${newId}?_file=${_file}`);
    };

    const handleSaveCorrect = async(idx) => {
        const update = await validateProduct({fileId,_file,id});
        fetchProduct(fileId, _file,id, fileId);
        //console.log("idx::>",idx);
    }

    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value.trim() });
    };

    const handleSave = async () => {
        try {
            const res = await updateProduct({fileId,_file, id},{uniqueProductName: formData.uniqueProductName, casNo: formData.CASNUMBER});
            // await axios.put(
            //     `http://localhost:8001/api/products/id/${id}`,
            //     formData,
            //     {
            //         headers: { Authorization: `Bearer ` },
            //     }
            // );
            setIsEditing(false);
            fetchProduct(fileId, _file,id, fileId);
        } catch (err) {
            alert(err.response?.data?.message || "Error updating product");
        }
    };

    const handleCancel = () => {
        setFormData({
            PRODUCT: product.PRODUCT,
            CASNUMBER: product.casNo,
            uniqueProductName: product.uniqueProductName.toUpperCase()
        });
        setIsEditing(false);
    };

    const handleClickQuery = (queryText) => {
        const encodedQuery = encodeURIComponent(queryText);
        window.open(`https://www.google.com/search?q=${encodedQuery}`, '_blank')
    }

    const handleClickPubChem = (queryText) => {
        const encodedQuery = encodeURIComponent(queryText);
        window.open(`https://pubchem.ncbi.nlm.nih.gov/#query=${encodedQuery}`, '_blank')
    }

    const handleClickCasChem = (queryText) => {
        const encodedQuery = encodeURIComponent(queryText);
        window.open(`https://commonchemistry.cas.org/results?q=${encodedQuery}`, '_blank')
    }

    const copyToClipboard = (text, className) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setCopiedClass(className);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <div className="dashboardmain">
            <div className="dashboardContainer">
                <h2 className="dashboardHeading">Product Dashboard</h2> 

                {error && <p className="errorMessage">{error}</p>}

                {product ? (
                    <div className="studentInfoContainer">
                        <p className="studentDetail">
                            Product IDs: <span className="detailValue">{product.ids.join(", ")}</span>
                        </p>

                        <p className="studentDetail">
                            Product Name:
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onInput={(e) =>
                                    handleChange("PRODUCT", e.currentTarget.textContent)
                                }
                            >
                                &nbsp;&nbsp;{formData.PRODUCT}
                            </span>
                        </p>

                        <p className="studentDetail">
                            CAS Number:
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onInput={(e) =>
                                    handleChange("CASNUMBER", e.currentTarget.textContent)
                                }
                            >
                                &nbsp;&nbsp;{formData.CASNUMBER}
                            </span>
                            {copied && copiedClass == "casNo" ? (
                                <FaCheck
                                    style={{ marginLeft: "8px", color: "green" }}
                                    title="Copied!"
                                />
                            ) : (
                                <FiCopy
                                    onClick={() => copyToClipboard(formData.CASNUMBER, "casNo")}
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                    }}
                                    title="Copy to clipboard"
                                />
                            )}
                        </p>

                        <p className="studentDetail">
                            Unique product name:
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onInput={(e) =>
                                    handleChange("uniqueProductName", e.currentTarget.textContent)
                                }
                            >
                                &nbsp;&nbsp;{formData.uniqueProductName}
                            </span>
                            {copied && copiedClass == "uniqueProductName" ? (
                                <FaCheck
                                    style={{ marginLeft: "8px", color: "green" }}
                                    title="Copied!"
                                    className="uniqueProductName"
                                />
                            ) : (
                                <FiCopy
                                    onClick={() => copyToClipboard(formData.uniqueProductName,"uniqueProductName" )}
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                    }}
                                    title="Copy to clipboard"
                                />
                            )}
                        </p>

                        <p className="studentDetail">
                            Search query 1 : 
                            <span
                                className="detailValue"
                                //contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onClick={(e) =>
                                    handleClickQuery(formData.uniqueProductName + ' cas number')
                                }
                                style={{textDecoration: 'underline'}}
                            >
                                &nbsp;&nbsp;{formData.uniqueProductName + ' cas number'}
                            </span>
                            <FaExternalLinkAlt
                                style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                }}
                            />
                        </p>

                        <p className="studentDetail">
                            Search query 2 : 
                            <span
                                className="detailValue"
                                //contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onClick={(e) =>
                                    handleClickQuery('is '+formData.CASNUMBER+' cas number of ' + formData.uniqueProductName + ' ' + ' ?')
                                }
                                style={{textDecoration: 'underline'}}
                            >
                                &nbsp;&nbsp;{'is "'+formData.CASNUMBER+'" cas number of ' + formData.uniqueProductName + ' ' + ' ?'}
                            </span>
                            <FaExternalLinkAlt 
                                style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                }}
                            />
                        </p>

                        <p className="studentDetail">
                            Search query 3 (pubchem) : 
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onClick={(e) =>
                                    handleClickPubChem(formData.uniqueProductName)
                                }
                                style={{textDecoration: 'underline'}}
                            >
                                &nbsp;&nbsp;{formData.uniqueProductName}
                            </span>
                            <FaExternalLinkAlt 
                                style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                }}
                            />
                        </p>

                        <p className="studentDetail">
                            Search query 4 (cas chem) : 
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onClick={(e) =>
                                    handleClickCasChem(formData.CASNUMBER)
                                }
                                style={{textDecoration: 'underline'}}
                            >
                                &nbsp;&nbsp;{formData.uniqueProductName}
                            </span>
                            <FaExternalLinkAlt 
                                style={{
                                        cursor: "pointer",
                                        marginLeft: "15px",
                                        color: "#fff",
                                        fontSize: "15px",
                                }}
                            />
                        </p>

                        {/* <p className="studentDetail">
                            Product Group:
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onInput={(e) =>
                                    handleChange("PRODUCT_GROUP", e.currentTarget.textContent)
                                }
                            >
                                {product.PRODUCT_GROUP}
                            </span>
                        </p> */}
                        <p className="studentDetail">
                            Verified:
                            <span
                                className="detailValue"
                                contentEditable={isEditing}
                                suppressContentEditableWarning={true}
                                onInput={(e) =>
                                    handleChange("CASNUMBER", e.currentTarget.textContent)
                                }
                                style={{color: product.verified ? 'yellow': 'red' }}
                            >
                                &nbsp;&nbsp;{product.verified ? "TRUE": "FALSE"}
                            </span>
                        </p>
                    </div>
                ) : (
                    <p className="noStudentMessage">No product found with ID {id}</p>
                )}

                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="studentActions">
                    {isEditing ? (
                        <>
                            <button className="editButton navButton" onClick={handleSave}>
                                Save
                            </button>
                            <button className="editButton navButton" onClick={handleCancel}>
                                Cancel
                            </button>
                        </>
                    ) : (
                        <button className="editButton navButton" onClick={() => setIsEditing(true)}>
                            Edit
                        </button>
                    )}
                        {/* <>
                           <button className="editButton navButton">
                            Add new 
                            </button>
                        </> */}
                </div>

                <div className="navigationButtons">
                    <button
                        className="navButton"
                        onClick={() => handleNavigate("prev")}
                        disabled={parseInt(id, 10) <= 1}
                    >
                        Previous
                    </button>
                    <button
                        className="navButton"
                        onClick={() => handleSaveCorrect(product.idx)}
                        style={{ marginLeft: "8px", backgroundColor: "green" }}
                    >
                        Validate
                    </button>
                    <button
                        className="navButton"
                        onClick={() => handleNavigate("next")}
                        style={{ marginLeft: "8px"}}
                    >
                        Next
                    </button>
                </div>
                </div>
            </div>
        </div>
    );
}

export default VerificationPortal